import { SyncEventType } from '../../enums/syncEventType';
import { WebRTCEvent } from './webRTCEvent';

export class WebRTCEventGotUserMedia implements WebRTCEvent {

  public readonly type = SyncEventType.WEBRTC_GOT_USER_MEDIA;
  // This field is purely informational, i.e. to check in syncserver if the message was delivered
  public readonly info = 'got user media message';


  constructor() { }


  getPayload(): object {
    return {
      info: this.info
    };
  }


}

